import React from 'react';
import { Typography } from '@mui/material';

const TarifaInfo = ({ isNonRefundable, idIntegration }) => {
  const isNemo = +idIntegration === 1;

  const variants = {
    nemo: {
      text: 'Consultar políticas de cancelación',
      sx: {
        fontSize: { xs: '18px', sm: '15px' },
        fontWeight: 700,
        color: '#ffb400',
      },
    },
    noReembolsable: {
      text: 'Tarifa No Reembolsable',
      sx: {
        fontSize: { xs: '18px', sm: '15px' },
        fontWeight: 700,
        color: 'red',
      },
    },
    reembolsable: {
      text: 'Tarifa Reembolsable',
      sx: {
        fontSize: { xs: '18px', sm: '15px' },
        fontWeight: 700,
        color: '#03C868',
      },
    },
  };

  let text;
  let sx;

  if (isNemo) {
    text = variants.nemo.text;
    sx = variants.nemo.sx;
  } else if (isNonRefundable) {
    text = variants.noReembolsable.text;
    sx = variants.noReembolsable.sx;
  } else {
    text = variants.reembolsable.text;
    sx = variants.reembolsable.sx;
  }

  return <Typography sx={sx}>{text}</Typography>;
};

export default TarifaInfo;
